"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatMap = exports.BUS_CHANNEL_NAME = void 0;
var tslib_1 = require("tslib");
var framebus_1 = tslib_1.__importDefault(require("framebus"));
var overlay_1 = require("./overlay");
var Types_1 = require("./Types");
exports.BUS_CHANNEL_NAME = "seatMap";
var SeatMap = (function () {
    function SeatMap(input) {
        var _this = this;
        this.container = null;
        this.iframe = null;
        this.areaId = null;
        this.productId = null;
        this.userId = null;
        this.salesChannelId = null;
        this.bus = null;
        this.overlay = null;
        this.onError = function (data) { };
        this.onLoaded = function (data, reply) { };
        this.onSeatClick = function (data, reply) { };
        this.onSeatMouseOver = function (data, reply) { };
        this.onSeatMouseOut = function (data, reply) { };
        this.onSeatSelectionUpdate = function (data, reply) { };
        this.destroy = function () {
            _this.destroyBusFrame();
            if (_this.iframe) {
                _this.iframe.remove();
                _this.iframe = null;
            }
            if (_this.overlay) {
                _this.overlay.destroy();
            }
        };
        this.serviceUrl = input.serviceUrl;
        this.containerSelector = input.containerSelector;
        this.version = input.version || "1";
        this.svgRendering = input.svgRendering || "2d";
    }
    Object.defineProperty(SeatMap.prototype, "url", {
        get: function () {
            var baseUrl = this.serviceUrl.replace(/\/$/, "");
            if (this.svgRendering === "3d") {
                if (!this.productId) {
                    return baseUrl + "/area/" + this.areaId;
                }
                return baseUrl + "/area/" + this.areaId + "/product/" + this.productId + "/salesChannel/" + this.salesChannelId;
            }
            var version = this.version === "1" ? "" : this.version === "2" ? "?version=2" : "?version=" + this.version;
            if (this.productId) {
                var userQuery = this.userId ? "/user/" + this.userId : "";
                return baseUrl + "/area/" + this.areaId + "/product/" + this.productId + "/salesChannel/" + this.salesChannelId + userQuery + version;
            }
            else {
                return baseUrl + "/area/" + this.areaId + version;
            }
        },
        enumerable: false,
        configurable: true
    });
    SeatMap.prototype.load = function (input) {
        if (!input.areaId) {
            throw new Error("areaId is required");
        }
        this.areaId = input.areaId;
        if (input.productId) {
            this.productId = input.productId;
            this.userId = input.userId;
            if (!input.salesChannelId) {
                throw new Error("salesChannelId is required when using productId");
            }
            else {
                this.salesChannelId = input.salesChannelId;
            }
        }
        if (input.options) {
            this.options = input.options;
        }
        console.log('url', this.url);
        this.createIframe(this.url);
        this.initializeBusFrame();
    };
    SeatMap.prototype.setSeatsStyle = function (seatIds, styleName) {
        if (styleName === void 0) { styleName = "default"; }
        if (!this.bus) {
            return;
        }
        this.bus.emit("setSeatsStyle", { styleName: styleName, seatIds: seatIds });
    };
    SeatMap.prototype.setCustomStyleGroup = function (data) {
        if (!this.bus) {
            return;
        }
        this.bus.emit('setCustomStyleGroup', data);
    };
    SeatMap.prototype.resetSelectedSeats = function () {
        if (!this.bus) {
            return;
        }
        this.bus.emit("resetSelectedSeats", {});
    };
    SeatMap.prototype.setSelectedSeats = function (seatIds) {
        if (!this.bus) {
            return;
        }
        this.bus.emit("setSelectedSeats", { data: seatIds });
    };
    SeatMap.prototype.unsetSelectedSeats = function (seatIds) {
        if (!this.bus) {
            return;
        }
        this.bus.emit("unsetSelectedSeats", { data: seatIds });
    };
    SeatMap.prototype.resetReservedSeats = function () {
        if (!this.bus) {
            return;
        }
        this.bus.emit("resetReservedSeats", {});
    };
    SeatMap.prototype.setReservedSeats = function (seatIds) {
        if (!this.bus) {
            return;
        }
        this.bus.emit("setReservedSeats", { data: seatIds });
    };
    SeatMap.prototype.unsetReservedSeats = function (seatIds) {
        if (!this.bus) {
            return;
        }
        this.bus.emit("unsetReservedSeats", { data: seatIds });
    };
    SeatMap.prototype.setSeatSelectionCountLimit = function (count) {
        if (count === void 0) { count = -1; }
        if (!this.bus) {
            return;
        }
        this.bus.emit("setSeatSelectionCountLimit", { count: count });
    };
    SeatMap.prototype.setSelectionMode = function (mode) {
        if (mode === void 0) { mode = Types_1.SelectionMode.SINGLE; }
        if (!this.bus) {
            return;
        }
        this.bus.emit("setSelectionMode", { mode: mode });
    };
    SeatMap.prototype.setCustomSeatStyles = function (data) {
        if (!this.bus) {
            return;
        }
        this.bus.emit("setCustomSeatStyles", { data: data });
    };
    SeatMap.prototype.initializeBusFrame = function () {
        var _this = this;
        if (this.bus) {
            throw new Error("could not initialize Framebus.");
        }
        this.bus = SeatMap.createBus();
        this.bus.on("seat:mouseover", this.onSeatMouseOver);
        this.bus.on("seat:mouseout", this.onSeatMouseOut);
        this.bus.on("seat:click", this.onSeatClick);
        this.bus.on("seatSelection:update", this.onSeatSelectionUpdate);
        this.bus.on("loaded", this.onLoaded);
        this.bus.on("error", this.onError);
        this.bus.on("loaded", function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (_this.overlay) {
                _this.overlay.hide();
                if (_this.options &&
                    "defaultSeatStyle" in _this.options &&
                    _this.options.defaultSeatStyle) {
                    (_a = _this.bus) === null || _a === void 0 ? void 0 : _a.emit("setDefaultSeatStyle", tslib_1.__assign({}, _this.options.defaultSeatStyle));
                }
                if (_this.options &&
                    "customSeatStyles" in _this.options &&
                    _this.options.customSeatStyles) {
                    (_b = _this.bus) === null || _b === void 0 ? void 0 : _b.emit("setCustomSeatStyles", {
                        data: _this.options.customSeatStyles,
                    });
                }
                if (_this.options &&
                    "onlyBookedIsSelectable" in _this.options &&
                    _this.options.onlyBookedIsSelectable) {
                    (_c = _this.bus) === null || _c === void 0 ? void 0 : _c.emit("onlyBookedIsSelectable", {
                        data: _this.options.onlyBookedIsSelectable,
                    });
                }
                else {
                    (_d = _this.bus) === null || _d === void 0 ? void 0 : _d.emit("onlyBookedIsSelectable", { data: false });
                }
                if (_this.options &&
                    "enableGuide" in _this.options &&
                    _this.options.enableGuide) {
                    (_e = _this.bus) === null || _e === void 0 ? void 0 : _e.emit("enableGuide", { data: _this.options.enableGuide });
                }
                else {
                    (_f = _this.bus) === null || _f === void 0 ? void 0 : _f.emit("enableGuide", { data: false });
                }
                if (_this.options &&
                    "popoverEnabled" in _this.options &&
                    _this.options.popoverEnabled) {
                    (_g = _this.bus) === null || _g === void 0 ? void 0 : _g.emit("popoverEnabled", {
                        data: _this.options.popoverEnabled,
                    });
                }
                else {
                    (_h = _this.bus) === null || _h === void 0 ? void 0 : _h.emit("popoverEnabled", { data: true });
                }
                if (_this.options &&
                    "customText" in _this.options &&
                    _this.options.customText) {
                    (_j = _this.bus) === null || _j === void 0 ? void 0 : _j.emit("customText", { data: _this.options.customText });
                }
                else {
                    (_k = _this.bus) === null || _k === void 0 ? void 0 : _k.emit("customText", { data: "Terrain" });
                }
            }
        });
    };
    SeatMap.prototype.destroyBusFrame = function () {
        if (this.bus) {
            this.bus.off("setFullScreenState", this.onLoaded);
            this.bus.off("seat:mouseover", this.onSeatMouseOver);
            this.bus.off("seat:mouseout", this.onSeatMouseOut);
            this.bus.off("seat:click", this.onSeatClick);
            this.bus.off("seatSelection:update", this.onSeatSelectionUpdate);
            this.bus.off("loaded", this.onLoaded);
            this.bus.off("error", this.onError);
            this.bus.teardown();
            this.bus = null;
        }
    };
    SeatMap.prototype.createIframe = function (url) {
        if (window == undefined) {
            throw new Error("error related to browser compatibility");
        }
        if (this.iframe) {
            this.destroy();
        }
        this.container = document.querySelector(this.containerSelector);
        if (!this.container) {
            throw new Error("Could not find element with selector : " + this.containerSelector);
        }
        this.iframe = window.document.createElement("iframe");
        var iframeId = "Ticketchainer";
        this.iframe.setAttribute("allowfullscreen", "");
        this.iframe.setAttribute("scrolling", "no");
        this.iframe.setAttribute("src", url);
        this.iframe.setAttribute("id", iframeId);
        this.iframe.style.position = "absolute";
        this.iframe.style.border = "0";
        this.iframe.style.top = "0";
        this.iframe.style.left = "0";
        this.iframe.style.width = "100%";
        this.iframe.style.height = "100%";
        this.overlay = new overlay_1.Overlay(this.container);
        this.container.appendChild(this.iframe);
    };
    SeatMap.createBus = function () {
        return new framebus_1.default({
            channel: exports.BUS_CHANNEL_NAME,
        });
    };
    return SeatMap;
}());
exports.SeatMap = SeatMap;
//# sourceMappingURL=SeatMap.js.map